import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'

import { Container, Row, Col } from 'react-grid-system'
import moment from 'moment-timezone'
import { roundHours, formatHours } from 'utils/time'

import Button from 'components/buttons/Button'
import Checkbox from 'components/Checkbox'
import SelectField from 'components/SelectField'
import TextField from 'components/TextField'

import TimePicker from 'material-ui/TimePicker'
import TimeInput from 'components/TimeInput'


import { LoadingBox } from 'components/LoadingSpinner'

import LeavesAPI from 'api/LeavesAPI'
import TimesheetsAPI from 'api/TimesheetsAPI'

import schema from './schema'
import styles from './index.css'


const validateTime = val => /^[0-9]{1,2}\:[0-9]{1,2}$/.test(val)

const breakToHmm = mins => {
  const h = Math.floor(mins / 60)
  const m = Math.floor(mins % 60)
  return `${h}:${m}` + (m == 0 ?  '0' : '')
}


class TimesheetFormEntry extends React.Component {

  static propTypes = {
    uid               : PropTypes.any.isRequired,
    timesheetId       : PropTypes.number.isRequired,
    defaultEntry      : PropTypes.object.isRequired,
    disabled          : PropTypes.bool.isRequired,
    leaves            : PropTypes.array.isRequired,
    onViewGPSDataClick: PropTypes.func.isRequired,
    onUpdated         : PropTypes.func,
  }

  static defaultProps = {
    onUpdated   : currentState => {}
  }


  constructor(props) {
    super(props) 
    this.state = {
      ...this.api2ui(props.defaultEntry),
      err_start_time: null,
      err_end_time: null,
      err_break: null
    }
  }

  api2ui = entry => {
    let res = {
      ...entry,
      allowances: {
        truck_overnight: (entry.allowances && entry.allowances.truck_overnight) || false,
        washing: (entry.allowances && entry.allowances.washing) || false,
      },
      manager_comment: `${entry.manager_comment || ''}`,
      date: entry.date ? new Date(entry.date) : null,
    }

    res.sessions = res.sessions.map((entry,i) => ({
      ...entry,
      id        : entry.id,
      start_time: entry.start_time ? moment(entry.start_time).format('H:mm'): '',
      end_time  : entry.end_time   ? moment(entry.end_time).format('H:mm')  : '',
      break     : entry.break      ? breakToHmm(entry.break)                : '',
    }))

    return res
  }

  ui2api = state => {
    return {
      ...state, 
      date: moment(state.date).format('YYYY-MM-DD')
    }
  }

  async update(fieldName, value, online, isTime = false) {
    const nested = /\./.test(fieldName)

    //const entry = { ...this.state.entries[index] }

    console.log("fieldName, value:", fieldName, value)

    /* if (isTime) {
      const v = validateTime(value)
      if (!v) {
        this.setState({ ['err_'+fieldName] : "Incorrect format" })
      } else {
        this.setState({ ['err_'+fieldName] : '' })
      }
    }
    */

    /* if (isTime) {
      const vv = moment(entry[fieldName]).toDate()
      const inp = value
      const hm = inp.split(':')
      if (hm.length == 2) {
        vv.setHours(hm[0])
        vv.setMinutes(hm[1])
      }
      value = vv.toISOString()
    }*/

    const t = this.props.timesheetId

   /* if (online) {
      const errs = {}  
      if (!validateTime(this.state.start_time)) {
        errs['err_start_time'] = "Incorrect format"
      }
      if (!validateTime(this.state.end_time)) {
        errs['err_end_time'] = "Incorrect format"
      }

      this.setState({ ...errs })
      if (Object.keys(errs).length > 0) {
        online = false
      }
    }*/

    const formatTimesOnline = (fieldName, value) => {
      let onlineValue = value

      if (['start_time', 'end_time', 'break'].includes(fieldName)) {
        const spl = value.split(':')
        if (spl.length !== 2 || spl[0].length == '' || spl[1].length == '') {
          return;
        }
      }

      if (fieldName=='start_time' || fieldName=='end_time') {
        onlineValue = new Date(this.state.date)
        const [h,m] = value.split(':')
        onlineValue.setHours(parseInt(h))
        onlineValue.setMinutes(parseInt(m))
        onlineValue = onlineValue.toISOString()
      }

      if (fieldName=='break') {
        const [h,m] = value.split(':')
        onlineValue = parseInt(h) * 60 + parseInt(m)
      }
      return onlineValue
    }

    if (nested) {
      const p = fieldName.split('.')

      if (!p[0].includes('sessions')) {
        const nestedFieldName = p[1]
        const p2 = { ...this.state[p[0]] }
        p2[nestedFieldName] = value
        this.setState({ [p[0]] : p2 })

        if (online) {
          const {response} = await TimesheetsAPI.updateEntry(t,  this.state.id, { [p[0]] : { [nestedFieldName] : value } })
        }
      } else {
        // sessions
        const [_, sid, field] = p
        const newSessions = [ ...this.state.sessions ]
        newSessions[newSessions.findIndex(({id}) => id == sid)][field] = value 

        this.setState({ sessions: newSessions })

        if (online) {
          const onlineValue = formatTimesOnline(field, value)
          const {response} = await TimesheetsAPI.updateEntry(t,  this.state.id, { sessions: [{id:sid, [field]:onlineValue}] })

          this.setState({ 
            err_break: null, 
            err_manager_comment: null 
          })
          this.setState({ total_hours: response.total_hours })
          this.props.onUpdated({ ...this.state })
        }
      }

    } else {

      this.setState({ [fieldName] : value })

      if (online) {

        let onlineValue = value

        const {response} = await TimesheetsAPI.updateEntry(t,  this.state.id, { [fieldName] : onlineValue })
        if (response && response.validationErrors) {
          const errs = {}
          for (let k in response.validationErrors) {
            errs['err_'+k] = response.validationErrors[k]            
          }
          this.setState({ ...errs })
        } else {
          this.setState({ 
            err_break: null, 
            err_manager_comment: null 
          })
          this.setState({ total_hours: response.total_hours })
          this.props.onUpdated({ ...this.state })
        }
      }
    }
  }

  render() {
    return (
      <Row key={this.key} className={styles.Row}>
        <Col xs={1}>
          <div className={styles.FirstColumn}>
            {moment(this.state.date).format('ddd, DD MMM')}
            <span 
              className={styles.GPSLink}
              onClick={() => {
                this.props.onViewGPSDataClick({
                  sessions: this.state.sessions
                })
              }}
            >View GPS Data</span>
          </div>
        </Col>
        <Col xs={3}>
          <Container>
            {
              (this.state.sessions || []).map((e, i) => 
                <Row key={i} className={styles.TimeInputsRow}>
                  <Col xs={4}  className={styles.TimeInputsCol}>
                    <TimeInput 
                      value={e.start_time}
                      onChange={(value) => this.update(`sessions.${e.id}.start_time`, value, true, true)}
                      errorText={e.err_start_time} 
                      disabled={this.props.disabled}
                      />
                  </Col>
                  <Col xs={4}  className={styles.TimeInputsCol}>
                    <TimeInput 
                      value={e.end_time}
                      onChange={(value) => this.update(`sessions.${e.id}.end_time`, value, true, true)}
                      errorText={e.err_end_time} 
                      disabled={this.props.disabled}
                      />
                  </Col>
                  <Col xs={4}  className={styles.TimeInputsCol}>
                    <TimeInput 
                      value={e.break}
                      onChange={(value) => this.update(`sessions.${e.id}.break`, value, true, true)}
                      errorText={e.err_break} 
                      disabled={this.props.disabled}
                      />
                  </Col>
                </Row>
              )
            }
          </Container>
        </Col>
        <Col xs={2}>
          <div style={{display:'flex', flexFlow: 'column'}}>
            <Checkbox 
              label='Truck overnight' 
              value={this.state.allowances && this.state.allowances.truck_overnight}
              onChange={value => this.update('allowances.truck_overnight', value, true)}
              disabled={this.props.disabled}
              />
            {/*<Checkbox 
              label='Washing' 
              value={this.state.allowances && this.state.allowances.washing}
              onChange={value => this.update('allowances.washing', value, true)}
              disabled={this.props.disabled}
            />*/}
          </div>
        </Col>
        <Col xs={2}>
          <TextField 
            value={this.state.manager_comment}
            onChange={value => this.update('manager_comment', value, false, false)}
            onBlur={value => this.update('manager_comment', value, true)}
            errorText={this.state.err_manager_comment} 
            smallErrors
            timeoutBlur={true}
            disabled={this.props.disabled}
            />
        </Col>
        <Col xs={2}>
          <SelectField 
            value={`${this.state.leave_id}`}
            onChange={value => this.update('leave_id', value, true)}
            disabled={this.props.disabled}
            >
            <option value={null}></option>
            {
              this.props.leaves.map((e,i) => 
                <option key={i} value={e.id}>{e.name}</option>
              )
            }
          </SelectField>
        </Col>
        <Col xs={1}>
          {formatHours(this.state.total_hours)}
        </Col>
        <Col xs={1}>
          <Checkbox 
            value={this.state.checked}
            onChange={value => this.update('checked', value, true)}
            disabled={this.props.disabled}
            />
        </Col>
      </Row>
    )
  }
}


export default class TimesheetForm extends React.Component {
  
  static propTypes = {
    id                : PropTypes.string.isRequired,
    onViewGPSDataClick: PropTypes.func.isRequired,
  }

  static defaultProps = {
    onApproved        : () => {},
    onViewGPSDataClick: () => {}
  }

  constructor(props) {
    super(props)
    this.fetchLeaves    = this.fetchLeaves.bind(this)
    this.fetchTimesheet = this.fetchTimesheet.bind(this)
    this.approve        = this.approve.bind(this)
  }

  state = {
    leaves   : [],
    timesheet: null,
    entries  : []
  }

  async fetchLeaves() {
    const {response} = await LeavesAPI.list()
    this.setState({ leaves: response })
  }

  async fetchTimesheet() {
    this.setState({ loading: true })

    const {response : timesheet} = await TimesheetsAPI.get(this.props.id)
    /*
    -------------------------
      debug simulate multiple sessions per day
    -------------------------
    
    const t2 = { ...timesheet }
    t2.entries = t2.entries.map((e,i) => {
      e.sessions = []
      for (var i = 0; i < 3; ++i) e.sessions.push({ start_time: e.start_time, end_time: e.end_time, break: e.break })
      return e
    })*/
    this.setState({ 
      timesheet
    })

    this.setState({ loading: false })
  }


  async approve() {
    this.setState({ approving: true })

    const {response} = await TimesheetsAPI.approve(this.state.timesheet.id)

    this.setState({ approving: false })

    await this.fetchTimesheet()
  }

  componentDidMount() {
    this.fetchLeaves()
    this.fetchTimesheet()
  }


  calculateTotalHours() {
   /* const durations = this.state.timesheet.entries 
      .map(e => e.total_hours)
      .filter(e => !!e)
      .map(e => e.split(':'))
    
    let minutes = 0
    for (let [h,m] of durations) {
      minutes += parseInt(h) * 60 + parseInt(m)
    }
    return `${Math.floor(minutes / 60)}:${Math.floor(minutes % 60)}`*/
    return formatHours(this.state.timesheet.entries 
            .map(e => e.total_hours)
            .reduce((a,b)=>a+b, 0))
  }

  render() {
    if (this.state.loading) return <LoadingBox />
    if (!this.state.timesheet) return null;
    const totalHours = this.calculateTotalHours()

    const formDisabled = this.state.timesheet.status !== 'pending'

    return (
      <div>
        <h1>{this.state.timesheet.employee_name}</h1>
        
        <Container className={styles.List}>
          <Row className={styles.Header}>
            <Col xs={1}>
              <h1>Date</h1>
            </Col>
            <Col xs={1}>
              <h1>Start</h1>
            </Col>
            <Col xs={1}>
              <h1>End</h1>
            </Col>
            <Col xs={1}>
              <h1>Breaks</h1>
            </Col>
            <Col xs={2}>
              <h1>Allowances</h1>
            </Col>
            <Col xs={2}>
              <h1>Manager Comment</h1>
            </Col>
            <Col xs={2}>
              <h1>Leave</h1>
            </Col>
            <Col xs={1}>
              <h1>Total</h1>
            </Col>
            <Col xs={1}>
              <h1>Hours checked</h1>
            </Col>
          </Row>
            {
              this.state.timesheet.entries.map((entry, i) => 
                <TimesheetFormEntry 
                  uid={`${i}`}
                  timesheetId={this.state.timesheet.id}
                  key={i} 
                  defaultEntry={entry} 
                  leaves={this.state.leaves}
                  disabled={formDisabled}
                  onViewGPSDataClick={this.props.onViewGPSDataClick}
                  onUpdated={({ total_hours }) => {
                    const newEntries = [ ...this.state.timesheet.entries ]
                    const i = newEntries.indexOf(entry)
                    newEntries[i].total_hours = total_hours
                    this.setState({ newEntries })
                  }}/>
              )
            }
        </Container>

        <div className={styles.ActionFooter}>
          <div>
            <h1>Total: {totalHours} hrs</h1>
          </div>
          {
            this.state.timesheet.status === 'pending' &&
              <Button 
                loading={this.state.approving}
                color='green'
                type='submit'
                onClick={this.approve}
                fullWidth={false}
                >Approve Time sheet
              </Button>
          }
          {
            this.state.timesheet.status === 'approved' &&
              <h1>Approved</h1>
          }
        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/forms/TimesheetForm/index.jsx